import { render, staticRenderFns } from "./EventPopupComponent.vue?vue&type=template&id=efa2cee6&scoped=true&"
import script from "./EventPopupComponent.vue?vue&type=script&lang=js&"
export * from "./EventPopupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa2cee6",
  null
  
)

export default component.exports